import { Skeleton } from "@coval/ui"

interface ClerkAuthFormSkeletonProps {
  /** Width of the heading placeholder — tweak per form so it roughly matches. */
  headingWidthClassName?: string
}

/**
 * Placeholder shown while Clerk is still initializing. Mirrors the real
 * email/password form layout (Google button, divider, two fields, submit,
 * footer link) so the swap to the live form doesn't shift anything.
 *
 * Shared by ClerkSignupForm / ClerkSigninForm and by the signup/signin routes,
 * which render it while `useAuth` is resolving so the page never flashes blank.
 */
export function ClerkAuthFormSkeleton({
  headingWidthClassName = "w-40",
}: ClerkAuthFormSkeletonProps) {
  return (
    <div className="space-y-6">
      <Skeleton className={`h-7 ${headingWidthClassName}`} />
      <Skeleton className="h-9 w-full rounded-md" />
      <div className="flex items-center gap-3">
        <Skeleton className="h-px flex-1" />
        <Skeleton className="h-3 w-4" />
        <Skeleton className="h-px flex-1" />
      </div>
      <div className="space-y-4">
        <div className="space-y-1">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-9 w-full rounded-md" />
        </div>
        <div className="space-y-1">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-9 w-full rounded-md" />
        </div>
      </div>
      <Skeleton className="h-9 w-full rounded-md" />
      <Skeleton className="h-4 w-44" />
    </div>
  )
}
